/**
 * Date/time for drop timeline UI (en-GB per project rules).
 */

export function formatDropTimelineAt(iso: string | null | undefined): string {
  const d = iso != null && iso !== '' ? new Date(iso) : new Date(NaN);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}

export function formatDropTimelineWindow(
  from: string | null | undefined,
  to: string | null | undefined,
): string {
  if (!from || !to) return '';
  return `${formatDropTimelineAt(from)} — ${formatDropTimelineAt(to)}`;
}

export function formatDropTimelineModalLabel(p: {
  resolvedUniqueId?: string;
  payloadUid: string;
  preparedId: string;
  wiserId?: number;
}): string {
  return (
    p.resolvedUniqueId ||
    p.payloadUid ||
    (p.preparedId !== '' ? `prepared ${p.preparedId}` : '') ||
    `drop #${p.wiserId ?? '?'}`
  );
}
